<template>
	<div class="form-group">
		<fieldset :aria-describedby="name + '-ids-hint'">
			<legend>
				<p v-if="$slots.question" class="input__question">
					<slot name="question"></slot>
					<i class="fas fa-asterisk" v-if="required"></i>
				</p>
			</legend>
			<div class="small" :id="name + '-ids-hint'">
				<slot name="description"></slot>
			</div>
			<div
				class="input__controls"
				v-for="opt in options"
				v-bind:key="opt.value"	
			>	
				<div v-if="opt.value == 'none'" class="form-group form-check">			
					<input
						type="checkbox"
						class="form-check-input"
						value="none"
						v-model="model"
						@click="onCheckboxChange"
					/>
					<label for="none" class="form-check-label form-label">None</label>	
				</div>
				<div v-else class="form-group form-check">
					<input 	
						type="checkbox"
						class="form-check-input"
						:value="opt.value"
						@click="onCheckboxChange"
						v-model="model"
					/>
					<label :for="opt.value" class="form-check-label form-label">
						{{ opt.label }}
					</label>
					<div 
						v-if="opt.description"
						class="text-muted d-block input__description"
						:id="'opt-ids-' + name + '-hint'">
						<small>{{ opt.description }}</small>
					</div>
				</div>
				<div
					v-if="opt.hasTextarea &&
					opt.textareaName &&
					optionIsChecked(opt.value)"
					class="conditional"
					:id="name + '-other-conditional'"
				>
					<div class="form-group">
						<label :for="opt.value" class="form-check-label form-label">
							{{ opt.conditionalText }}
						</label>
						<input
							:id="opt.value"
							type="text"
							class="form-control"
							:name="opt.textareaName"
							@input="onTextChange(opt.textareaName, $event.target.value)"	
						/>
						<p
							class="form-error"
							v-if="form.errors.get(opt.textareaName)"
							v-text="form.errors.get(opt.textareaName)"
							role="alert"
							aria-live="assertive">
						</p>	
					</div>
				</div>
			</div>
			<p class="form-error" v-if="error" v-text="error" role="alert" aria-live="assertive"></p>
		</fieldset>
	</div>
</template>
  
<script setup>
const props = defineProps({
	error: String,
	name: String,
  	options: Array,
	form: Object,
	required: Boolean
});

const model = defineModel()

const emit = defineEmits(['update:modelValue', 'textareaUpdated'])

function optionIsChecked (value) {
	return model.value.includes(value);
}

function onTextChange(field, value) {
	emit("textareaUpdated", { field, value });
}

function onCheckboxChange($event) {
	var previouslySelected = model.value || [];
	var newValue = [];
	if ($event.target.checked) {
		newValue = [...previouslySelected, $event.target.value];
	} else {
		newValue = previouslySelected.filter(
			(x) => x != $event.target.value
		);
	}
	
	if ($event.target.value === 'none' || $event.target.value === 'involved_none_above') {
		newValue = [$event.target.value];
	}
	
	model.value = newValue
	
	emit("update:modelValue", newValue);
}

</script>



	